module.exports = __webpack_public_path__ + "img/img4.767a0034.jpg";